import React, { useState } from "react";

import { FORM_ERROR } from "final-form";
import { Form as FinalForm, Field } from "react-final-form";
import { Form, Button, Grid, GridColumn, Header } from "semantic-ui-react";
import {
  registerIdentification,
  cleanRegister,
} from "../../../../app/store/actions/registerActions";
import TextInput from "../../../../app/common/form/TextInput";
import ErrorMessage from "../../../../app/common/form/ErrorMessage";
import SelectedInput from "../../../../app/common/form/SelectedInput";
import { tipoDocumentoOptions } from "../../../../app/config/data/options";
import {
  combineValidators,
  isRequired,
  composeValidators,
  isRequiredIf,
  hasLengthBetween,
} from "revalidate";
import { connect } from "react-redux";
import RegisterFormHeader from "./header/RegisterFormHeader";
import RegisterFormStep from "./step/RegisterFormStep";
import {
  CODIGO_TIPO_DOCUMENTO_RUC,
  CODIGO_TIPO_DOCUMENTO_DNI,
  LONGITUD_TIPO_DOCUMENTO_DNI,
} from "../../../../app/infrastructure/appConstants";
import RegisterCancel from "./RegisterCancel";
import {
  normalizeNumeroDocumentoIdentidad,
  getLengthNumeroDocumentoIdentidad,
} from "../../../../app/util/finalFormUtils";
import RegisterRecover from "./RegisterRecover";
import PropTypes from "prop-types";

const actions = {
  registerIdentification,
  cleanRegister,
};

const RegisterIdentificationForm = ({ registerIdentification }) => {
  const [
    identificacionRepresentanteLegal,
    setidentificacionRepresentanteLegal,
  ] = useState(false);

  const [tipoDocumentoCliente, setTipoDocumentoCliente] = useState(
    CODIGO_TIPO_DOCUMENTO_DNI
  );

  const [tipoDocumentoRepresentante, setTipoDocumentoRepresentante] = useState(
    CODIGO_TIPO_DOCUMENTO_DNI
  );

  const [
    lengthNumeroDocumentoCliente,
    setLengthNumeroDocumentoCliente,
  ] = useState(LONGITUD_TIPO_DOCUMENTO_DNI);

  const [
    lengthNumeroDocumentoRepresentante,
    setLengthNumeroDocumentoRepresentante,
  ] = useState(LONGITUD_TIPO_DOCUMENTO_DNI);

  const onChangeTipoDocumentoCliente = (value) => {
    setTipoDocumentoCliente(value);
    // Si tipo documento de cliente es RUC se habilita campos de representante legal
    setidentificacionRepresentanteLegal(
      value && value === CODIGO_TIPO_DOCUMENTO_RUC
    );
    //Actualizando longitud
    setLengthNumeroDocumentoCliente(getLengthNumeroDocumentoIdentidad(value));
  };

  const onChangeTipoDocumentoRepresentante = (value) => {
    setTipoDocumentoRepresentante(value);
    //Actualizando longitud
    setLengthNumeroDocumentoRepresentante(
      getLengthNumeroDocumentoIdentidad(value)
    );
  };

  const validate = combineValidators({
    tipoDocumentoCliente: composeValidators(
      isRequired({ message: "Tipo de documento es requerido" })
    )(),
    numeroDocumentoCliente: composeValidators(
      isRequired({ message: "Número de documento es requerido" }),
      hasLengthBetween(
        lengthNumeroDocumentoCliente,
        lengthNumeroDocumentoCliente
      )({
        message: "Número de documento del cliente no válido",
      })
    )(),
    tipoDocumentoRepresentante: composeValidators(
      isRequiredIf(
        (values) =>
          values && values.tipoDocumentoCliente === CODIGO_TIPO_DOCUMENTO_RUC
      )({
        message: "Tipo de documento del representante legal es requerido",
      })
    )(),
    numeroDocumentoRepresentante: composeValidators(
      isRequiredIf(
        (values) =>
          values && values.tipoDocumentoCliente === CODIGO_TIPO_DOCUMENTO_RUC
      )({
        message: "Número de documento del representante legal es requerido",
      }),
      hasLengthBetween(
        lengthNumeroDocumentoRepresentante,
        lengthNumeroDocumentoRepresentante
      )({
        message: "Número de documento del representante no es válido",
      })
    )(),
  });

  return (
    <FinalForm
      onSubmit={(values) =>
        registerIdentification(values).catch((error) => ({
          [FORM_ERROR]: error,
        }))
      }
      initialValues={{
        tipoDocumentoCliente: tipoDocumentoCliente,
      }}
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit,
      }) => (
        <Form onSubmit={handleSubmit} error>
          <br />
          <RegisterFormHeader />
          <RegisterFormStep />
          <Field
            name="tipoDocumentoCliente"
            component={SelectedInput}
            placeholder="Tipo de documento"
            options={tipoDocumentoOptions}
            handleOnChange={onChangeTipoDocumentoCliente}
          />
          <Field
            name="numeroDocumentoCliente"
            component={TextInput}
            placeholder="Número de documento"
            parse={(value) =>
              normalizeNumeroDocumentoIdentidad(value, tipoDocumentoCliente)
            }
            maxLength={lengthNumeroDocumentoCliente}
          />

          {identificacionRepresentanteLegal && (
            <>
              <Header as="h5" color="blue" textAlign="left">
                Representante legal
              </Header>
              <Field
                name="tipoDocumentoRepresentante"
                component={SelectedInput}
                placeholder="Tipo de documento"
                options={tipoDocumentoOptions}
                handleOnChange={onChangeTipoDocumentoRepresentante}
              />
              <Field
                name="numeroDocumentoRepresentante"
                component={TextInput}
                placeholder="Número de documento"
                parse={(value) =>
                  normalizeNumeroDocumentoIdentidad(
                    value,
                    tipoDocumentoRepresentante
                  )
                }
                maxLength={lengthNumeroDocumentoRepresentante}
              />
            </>
          )}

          {submitError && !dirtySinceLastSubmit && (
            <ErrorMessage error={submitError} />
          )}

          <br />

          <Grid divided="vertically">
            <Grid.Row columns={2}>
              <GridColumn>
                <RegisterCancel />
              </GridColumn>
              <GridColumn>
                <Button
                  fluid
                  disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                  size="large"
                  loading={submitting}
                  color="yellow"
                  content="Aceptar"
                />
              </GridColumn>
            </Grid.Row>
          </Grid>

          <br />
        </Form>
      )}
    />
  );
};
RegisterIdentificationForm.propTypes = {
  registerIdentification: PropTypes.func.isRequired,
};
export default connect(null, actions)(RegisterIdentificationForm);
